import CMSController from "@/api/controller/cmsController";
import { createApiGetAsyncThunk } from "@/store/utils";

import {
  selectAcceptTermsAndConditionsPage,
  selectBusinesses,
  selectBusinessNewsletters,
  selectCloseAccountPage,
  selectClubPage,
  selectFooter,
  selectGoodbyePage,
  selectInvestorLoyaltyBenefit,
  selectLocationsPage,
  selectMenu,
  selectMyGiftCardPage,
  selectNewslettersPage,
  selectPreviousTermsAndConditionsPage,
  selectPrivateHomePage,
  selectProfilePage,
  selectPublicHomePage,
  selectTermsAndConditionsPage,
} from "./selectors";

export const fetchPublicHomePage = createApiGetAsyncThunk(
  "CMS/fetchPublicHomePage",
  CMSController.fetchPublicHomePage,
  selectPublicHomePage,
);

export const fetchPrivateHomePage = createApiGetAsyncThunk(
  "CMS/fetchPrivateHomePage",
  CMSController.fetchPrivateHomePage,
  selectPrivateHomePage,
);

export const fetchProfilePage = createApiGetAsyncThunk(
  "CMS/fetchProfilePage",
  CMSController.fetchMyInfoPage,
  selectProfilePage,
);

export const fetchMenu = createApiGetAsyncThunk(
  "CMS/fetchMenu",
  CMSController.fetchMenu,
  selectMenu,
);

export const fetchClubPage = createApiGetAsyncThunk(
  "CMS/fetchClubPage",
  CMSController.fetchMyApolloClubPage,
  selectClubPage,
);

export const fetchBusinesses = createApiGetAsyncThunk(
  "CMS/fetchBusinesses",
  CMSController.fetchBusinesses,
  selectBusinesses,
);

export const fetchMyGiftCardPage = createApiGetAsyncThunk(
  "CMS/fetchMyGiftCardPage",
  CMSController.fetchMyGiftCardsPage,
  selectMyGiftCardPage,
);

export const fetchAcceptTermsAndConditionsPage = createApiGetAsyncThunk(
  "CMS/fetchAcceptTermsAndConditionsPage",
  CMSController.fetchAcceptTermsAndConditionsPage,
  selectAcceptTermsAndConditionsPage,
);

export const fetchNewslettersPage = createApiGetAsyncThunk(
  "CMS/fetchNewslettersPage",
  CMSController.fetchNewslettersPage,
  selectNewslettersPage,
);

export const fetchCloseAccountPage = createApiGetAsyncThunk(
  "CMS/fetchCloseAccountPage",
  CMSController.fetchCloseAccountPage,
  selectCloseAccountPage,
);

export const fetchGoodbyePage = createApiGetAsyncThunk(
  "CMS/fetchGoodbyePage",
  CMSController.fetchGoodbyePage,
  selectGoodbyePage,
);

export const fetchBusinessNewsletters = createApiGetAsyncThunk(
  "CMS/fetchBusinessNewsletters",
  CMSController.fetchBusinessNewsletters,
  selectBusinessNewsletters,
);

export const fetchLocationsPage = createApiGetAsyncThunk(
  "CMS/fetchLocationsPage",
  CMSController.fetchLocationsPage,
  selectLocationsPage,
);

export const fetchTermsAndConditionsPage = createApiGetAsyncThunk(
  "CMS/fetchTermsAndConditionsPage",
  CMSController.fetchTermsAndConditionsPage,
  selectTermsAndConditionsPage,
);

export const fetchPreviousTermsAndConditionsPage = createApiGetAsyncThunk(
  "CMS/fetchPreviousTermsAndConditionsPage",
  CMSController.fetchPreviousTermsAndConditionsPage,
  selectPreviousTermsAndConditionsPage,
);

export const fetchFooter = createApiGetAsyncThunk(
  "CMS/fetchFooter",
  CMSController.fetchFooter,
  selectFooter,
);

export const fetchInvestorLoyaltyBenefit = createApiGetAsyncThunk(
  "CMS/fetchInvestorLoyaltyBenefit",
  CMSController.fetchInvestorLoyaltyBenefit,
  selectInvestorLoyaltyBenefit,
);
